export default function () {
  if (window.location === window.parent.location) {
    return true
  }
  return false
}



// WEBPACK FOOTER //
// ./src/helpers/isStandalone.js